<template>

<div class="backgroundFilter" ref="filter">
    <div class="topImage">
      <img class="laptop" :src="`${previewsServer}/textures/ui/new/laptop.jpg`">
      <img class="sticker" :src="`${previewsServer}/textures/ui/new/sticker.png`">
      <img class="arrow" :src="`${previewsServer}/textures/ui/new/pijl.png`">
      <img class="logo-inside" :src="`${previewsServer}/textures/ui/new/logo.png`">
    </div>
    <p class="title">WELKOM BIJ DE <span>TOPLAWOOD</span><br/>BUITENVERBLIJVEN-CONFIGURATOR</p>
    <p>Wilt u verdergaan waar u was gebleven?</p>
    <button @click="hideFilter(false)">Ja, ik wil verder gaan waar ik ben gebleven.</button>
    <button @click="hideFilter(true)">Nee, ik wil opnieuw beginnen.</button>
    <p class="tip"><span>TIP:</span> Gebruik de <span>desktopversie</span> van onze website voor de beste ervaring met onze configurator.</p>
    <img class="logo" :src="`${previewsServer}/textures/ui/new/logo.png`">
</div>

</template>

<script>
  export default {
    name: "ConfirmHistory",

    // uncomment this if you want to disable this message
    // mounted() {
    //   setTimeout(() => {
    //     this.hideFilter(true);
    //   }, 1000);
    // },

    data () {
      return {
        //position: 0,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
      }
    },

    methods: {
      hideFilter(reset) {
        this.$refs.filter.style.opacity=0; 
        this.$refs.filter.style.pointerEvents='none';

        if(!reset) {
          this.$store.dispatch('initializeHistory')
          this.$store.dispatch('setConfigToCurrent')
        }

        setTimeout(() => {
          this.$emit('continue')
        }, 0);
      }
    }
  }
</script>

<style lang="scss" scoped>
.topImage {
  position: relative;
  display: inline-block;
}

.laptop {
  width: 777px;
  border-radius: 30px;
  display: block;
  @media (max-width: 999px) {
    display: none;
  }
}

.logo-inside {
  position: absolute;
  left: 16px;
  top: 16px;
  width: 215px;
  pointer-events: none;
  @media (max-width: 999px) {
    display: none;
  }
}

.sticker {
  position: absolute;
  bottom: 16px;
  right: 16px;
  width: 230px;
  pointer-events: none;
  @media (max-width: 999px) {
    position: inherit;
  }
}

.arrow {
  position: absolute;
  right: -20px;
  bottom: -145px;
  width: 200px;
  pointer-events: none;
  transform: scale(-1, 1);
  rotate: -110deg;
  @media (max-width: 999px) {
    display: none;
  }
}

.title {
  color: #57575B;
  font-family: 'Oswald', sans-serif;
  font-weight: 400;
  font-size: 40px;

  @media (max-width: 999px) {
    font-size: 28px;
  }

  span {
    font-family: 'Oswald', sans-serif;
    font-weight: 600;
  }
}

.tip {
  color: #57575B;
  font-weight: 300;
  margin-top: 100px;

  @media (max-width: 999px) {
    display: none;
  }

  span {
    font-weight: 600;
  }
}

.logo {
  display: none;
  margin-top: 100px;
  height: 119px;
  @media (max-width: 999px) {
    display: inherit;
  }
}

// styling for the whole sidebar
.backgroundFilter {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  opacity: 1;
  transition: opacity 1s ease-in-out;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

p {
  color: #57575B;
  margin: 0px auto;
  margin-top: 25px;
  max-width: 90%;
  font-size: 24px;
  font-weight: 400;
  display: inline-block;
  word-wrap: break-word;
  @media (max-width: 999px) {
    font-size: 18px;
  }
}

button {
  background-color: $c-primary;
  font-size: 20px;
  color: $c-secondary;
  border: none;
  border-radius: $radius-s;
  font-weight: 600;
  padding: 8px 0px;
  margin-top: 20px;
  width: 472px;
  word-wrap: break-word;
  cursor: pointer;
  @media (max-width: 999px) {
    width: 336px;
    font-size: 15px;
  }
}
</style>